import update from 'immutability-helper';
import { AnyAction, Dispatch } from 'redux';

import { TechnicalType } from '../interfaces/TechnicalType';
import { loadTimeMeasurementTypes as doLoadTimeMeasurementTypes } from '../services/loadTimeMeasurementTypes';

// Actions
const START_LOAD = 'common/timeMeasurementTypes/START_LOAD';
const COMPLETE_LOAD = 'common/timeMeasurementTypes/COMPLETE_LOAD';
const FAIL_LOAD = 'common/timeMeasurementTypes/FAIL_LOAD';
const RESET = 'common/timeMeasurementTypes/RESET';

// Initial state
const initialState = {
  isLoading: false,
  timeMeasurementTypes: [] as TechnicalType[],
};

// Reducer
export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: {
          isLoading: true,
        },
      });

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          timeMeasurementTypes: action.timeMeasurementTypes,
        },
      });

    case FAIL_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          timeMeasurementTypes: [],
        },
      });

    case RESET:
      return update(state, {
        $merge: initialState,
      });

    default:
      return state;
  }
};

// Action creators
const startLoad = () => ({
  type: START_LOAD,
});

const completeLoad = (timeMeasurementTypes: TechnicalType[]) => ({
  type: COMPLETE_LOAD,
  timeMeasurementTypes,
});

const failLoad = () => ({
  type: FAIL_LOAD,
});

export const loadTimeMeasurementTypes = () => (dispatch: Dispatch) => {
  dispatch(startLoad());
  const loadTimeMeasurementTypesPromise = doLoadTimeMeasurementTypes();
  loadTimeMeasurementTypesPromise
    .then((timeMeasurementTypes: TechnicalType[]) => dispatch(completeLoad(timeMeasurementTypes)))
    .catch(() => dispatch(failLoad()));
  return loadTimeMeasurementTypesPromise;
};

export const resetTimeMeasurementTypes = () => ({
  type: RESET,
});
